import type { ComparisonOperatorValue } from '@witmetrics/utils';
import { COMPARISON_OPERATORS } from '@witmetrics/utils/constants';
import type { SelectDropdownOption } from '@/components/inputs/SelectDropdown';

export const ORDER_STATUS = {
  key: 'orderStatusId',
  value: 'orderStatusId',
  label: 'Status',
} as const;

export const CUSTOMER = {
  key: 'practiceId',
  value: 'practiceId',
  label: 'Customer',
} as const;

export const COMPARISON_OPERATOR_OPTIONS: SelectDropdownOption<ComparisonOperatorValue>[] =
  [COMPARISON_OPERATORS.EQUALS, COMPARISON_OPERATORS.DOES_NOT_EQUAL];
